// Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
  PORTAL_BRANDING: 'portal_branding',
} as const

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    VALIDATE: '/auth/validate',
    FORGET_PASSWORD: '/auth/forget-password',
    SET_PASSWORD: '/auth/password',
  },
  IMPERSONATION: {
    BY_USER_ID: (id: string) => `/users/${id}/impersonate`,
  },
  USERS: {
    BASE: '/users',
    NEO: '/users/neo',
    RESELLERS: '/users/resellers',
    WHOLESALERS: '/users/wholesalers',
    ATTACHED_RESELLERS: '/users/attached-resellers',
    CURRENT: '/users/current',
    UPDATE_CURRENT: '/users/current',
    BY_ID: (id: string) => `/users/${id}`,
    VERIFY: '/users/verify',
    VERIFY_PASSWORD: '/users/verify-password',
  },
  CLIENTS: {
    BASE: '/clients',
    ATTACHED: '/clients/attached',
    BY_ID: (id: string) => `/clients/${id}`,
    ENABLE: (id: string) => `/clients/${id}/enable`,
    DISABLE: (id: string) => `/clients/${id}/disable`,
    BLOCK: (id: string) => `/clients/${id}/block`,
    UNBLOCK: (id: string) => `/clients/${id}/unblock`,
    TERMINATE: (id: string) => `/clients/${id}/terminate`,
  },
  GROUPS: {
    BASE: '/groups',
    BY_ID: (id: string) => `/groups/${id}`,
    EQUIPMENT: (id: string) => `/groups/${id}/equipment-config`,
    SERVER: (id: string) => `/groups/${id}/server-config`,
    CERTIFICATES: (id: string) => `/groups/${id}/certificates`,
  },
  LOGS: {
    BASE: '/logs',
    BY_SOURCE: (source: string) => `/logs/${source}`,
  },
  KPIS: {
    BASE: '/kpis',
    BY_ID: (id: string) => `/kpis/${id}`,
    ACTIVATE: (id: string) => `/kpis/${id}/active`,
    DEACTIVATE: (id: string) => `/kpis/${id}/inactive`,
    EVALUATE: (id: string) => `/kpis/${id}/evaluate`,
  },
  STATISTICS: {
    BASE: '/statistics',
  },
  GRID_CONFIGURATIONS: {
    BASE: '/grid-configurations',
  },
  SETTINGS: {
    BASE: '/settings',
    REGIME: '/settings/regime',
  },
  APK: {
    DEFAULT: '/apk/default',
    ASSIGNED: '/apk/assigned',
    ASSIGNED_DOWNLOAD: '/apk/assigned/download',
    USER: (userId: string) => `/apk/users/${userId}`,
  },
  INVOICES: {
    BASE: '/invoices',
    BY_ID: (id: string) => `/invoices/${id}`,
    BILLING_CONFIG: '/invoices/billing-config',
    GENERATE: '/invoices/generate',
  },
} as const

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur réseau. Veuillez vérifier votre connexion.',
  UNAUTHORIZED: "Vous n'êtes pas autorisé à effectuer cette action.",
  FORBIDDEN: 'Accès interdit.',
  NOT_FOUND: 'Ressource introuvable.',
  VALIDATION_ERROR: 'Veuillez vérifier vos informations et réessayer.',
  SERVER_ERROR: 'Erreur serveur. Veuillez réessayer plus tard.',
  MISSMATCH_CREDENTIALS: 'Email ou mot de passe invalide.',
  CODE_MISSMATCH_EXPIRED: 'Code invalide ou expiré.',
  TOKEN_INVALID_EXPIRED: 'Le lien de réinitialisation est invalide ou a expiré. Veuillez demander un nouveau lien.',
  USER_NOT_FOUND: 'Utilisateur introuvable.',
  USER_EMAIL_EXISTS: 'Cet email est déjà utilisé par un autre utilisateur.',
  UNKNOWN_ERROR: "Une erreur inattendue s'est produite.",
} as const

// Validation Patterns
export const VALIDATION_PATTERNS = {
  PHONE: /^(06|07)\d{8}$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]*$/,
  HEX_COLOR: /^#[0-9A-Fa-f]{6}$/,
} as const

// Login Code
export const LOGIN_CODE_EXPIRY_MINUTES = 3
